<template>
	<div id="app">
		<!-- <img src="./assets/logo.png"> -->
		<router-view />

		<div class="mask_wx" v-if="isWx"><img src="./assets/img/mask_wx.png" alt="" /></div>
	</div>
</template>

<script>
export default {
	name: 'App',
	data: function () {
		return {
			isWx: false
		};
	},
	mounted: function () {
		this.maskWx();
	},
	computed: {},
	methods: {
		maskWx() {
			let ua = navigator.userAgent.toLowerCase();
			let isWeixin = ua.indexOf('micromessenger') != -1;
			// 允许在微信内使用的页面（如长按识别群二维码）不显示微信遮罩。
			const pathname = window.location.pathname.replace(/\/$/, '');
			if (isWeixin && !['/official-accounts-coupon', '/qiwei-tuiguang', '/fanswelfare', '/shanghu-introduce', '/assistance-time', '/delta-force-group'].includes(pathname)) {
				this.isWx = true;
			}
		}
	}
};
</script>

<style lang="scss">
@import './style/base';
@font-face {
	font-family: 'iconfont'; /* project id 252520 */
	src: url('//at.alicdn.com/t/font_252520_am9vss8p6sr.eot');
	src:
		url('//at.alicdn.com/t/font_252520_am9vss8p6sr.eot?#iefix') format('embedded-opentype'),
		url('//at.alicdn.com/t/font_252520_am9vss8p6sr.woff') format('woff'),
		url('//at.alicdn.com/t/font_252520_am9vss8p6sr.ttf') format('truetype'),
		url('//at.alicdn.com/t/font_252520_am9vss8p6sr.svg#iconfont') format('svg');
}
#app {
	.mask_wx {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.94);
		overflow: hidden;
		img {
			display: block;
			width: px2rem(750rem);
			height: px2rem(270rem);
			margin: 0.12rem auto;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue